module.exports = __webpack_public_path__ + "static/img/IP-sz.e8880610.webp";